interface ServiceTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const ServiceTabs = ({ activeTab, onTabChange }: ServiceTabsProps) => {
  const tabs = [
    { id: 'ocean', label: 'Ocean Freight', icon: 'ri-ship-line' },
    { id: 'air', label: 'Air Freight', icon: 'ri-plane-line' },
    { id: 'road', label: 'Road Transport', icon: 'ri-truck-line' },
    { id: 'rail', label: 'Rail Logistics', icon: 'ri-train-line' },
    { id: 'warehousing', label: 'Warehousing', icon: 'ri-building-line' },
    { id: 'customs', label: 'Customs', icon: 'ri-file-list-3-line' },
  ];

  return (
    <div className="bg-white border-b sticky top-20 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center space-x-2 px-6 py-4 font-medium transition-all whitespace-nowrap border-b-4 ${
                activeTab === tab.id
                  ? 'border-primary-blue text-primary-blue'
                  : 'border-transparent text-gray-600 hover:text-primary-blue'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceTabs;